import type {NextPage} from 'next'
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import React from 'react';
import LandingLayout from "../src/layouts/LandingLayout";
import DesktopHeroArea from "../src/components/desktopHeroArea/DesktopHeroArea";
import {useWindowSize} from "../src/utils/Hooks";
import MobileKayitForm from "../src/components/mobileKayitForm/MobileKayitForm";
import WaveLayout from "../src/layouts/WaweLayout";
import styled from "styled-components";
import {deviceMax} from "../styles/device";
import LandingSubHeroArea from "../src/components/landing/LandingSubHeroArea";
import LandingColumnComp from "../src/components/landing/LandingColumnComp";

import reklammarried from "/public/next/images/landing/reklam-married-min.webp";
import Image from "next/image";

const SiteTuru: NextPage = () => {

    const windowSize = useWindowSize();

    const data = {
        LandingSubHeroAreaData: {
            breadcrumb: 'PEMBE PANJUR > SİTE > SİTE TURU',
            saying: '10 BİNLERCE ÇİFTİ MUTLU SONA ULAŞTIRDIK',
            propertyTopImg: '/next/assets/images/icons/icon-2.svg',
            propertyTopTitle: 'GERÇEK AŞK ŞİMDİ SANDIĞINIZDAN ÇOK DAHA YAKIN. !',
            propertyTopContent: "Pembe Panjur, kurulduğu 2010 yılından bugüne yüzlerce sayısız çifte hayatlarını birleştirme şansı yarattı.Teknolojik altyapısıyla başarılı bir eşleştirme sistemini hayata geçiren Pembe Panjur, o günden bu yana istikrarlı ve sürdürülebilir büyüme ile üye sayısını 10 milyonun üzerine çıkardı. Bu sayıyla Türkiye'nin en büyük evlilik sitesi unvanını elde etti.Bugün yalnızca Türkiye'den değil, dünyadan da pek çok Pembe Panjur üyesi yeni birlikteliklerine Pembe Panjur ile adım atıyor. Pembe Panjur'u diğer arkadaşlık ve evlilik sitelerinden ayrıştıran eşleştirme sistemi, çiftlerin uyumlu birliktelik kurma olasılığını artırıyor. Sizde Pembe Panjur’a ücretsiz üye olup mutlu bir birliktelik için ilk adımı atabilirsiniz. ",
            propertyMiddleImg: '/next/assets/images/icons/icon-9.svg',
            propertyMiddleTitle: 'BEŞ ADIMDA MUTLULUĞUNUZU SİZ YARATIN!',
            propertyMiddleContent: "Pembe Panjur'da ilk adım olan karakter analizi, sizin uygun kişi ile eşleşmeniz için gerekli olan ilk ve en önemli adımdır. İkinci adım ise kişisel profiliniz sizin kendinizi daha iyi yansıtmanızı sağlar. Resimleriniz ve kendinizi anlatacağınız yazılar sadece size uygun üyeler tarafından görülebilir.Üçüncü adım bilimsel eşleştirme sistemimiz, verdiğiniz bilgileri ve aradığınız kişisel özellikleriniz bir araya getirip sizin için uygun üyeleri bulur.Dördüncü adım ise gizlilik, Pembe Panjur'da oluşturacağınız üyelikle tamamen gizlilik çerçevesinde gönül rahatlığıyla hayatınızın aşkını bulmanız mümkün.Beşinci adım İletişim adımı ilettiğiniz bilgiler doğrultusunda, sistemimizin belirlediği kişiler ile iletişime geçebilirsiniz.",
            propertyBottomImg: '/next/assets/images/icons/icon-1.svg',
            propertyBottomTitle: 'ŞİMDİ KAYDOLUN',
            propertyBottomContent: "PEMBE PANJUR’A ÜYE OLUN, MUTLULUĞUNUZA BİR ADIM DAHA YAKLAŞIN. VERMİŞ OLDUĞUNUZ BİLGİLERİNİZ İLE SİZE UYGUN OLAN KİŞİYİ BİLİMSEL EŞLEŞTİRME SİSTEMİMİZLE BİZ BULALIM."
        }
    }

    return (
        <React.Fragment>
            <HtmlHead
                pageTitle={'Pembe Panjur | Site Turu | Türkiye\'nin En Ciddi Arkadaşlık & Evlilik Sitesi'}
                description={'Pembe Panjur, ciddi ilişki arayanları bilimsel kişilik testi ve sosyo-ekonomik yaşam analizi ile eşleştiren tanışma sitesi olup, aynı zamanda flört ve evlilik sitesidir.'}
                canonical={true}
            />
            <style jsx global>{`
                body, body.amp-mode-touch {
                    font-family: 'Manrope', sans-serif;
                    background-color: rgba(0, 0, 0, 0.04);
                }

                .advertisement-content-container {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    box-sizing: border-box;
                    padding: 40px 24px 65px 24px;
                    background: rgba(0, 0, 0, 0.03);
                }

                .advertisement-content-container > .advertisement-content-wrapper {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    grid-gap: 100px;
                    padding: 0 calc(50vw - 575px);
                }

                .advertisement-content-container > .advertisement-content-wrapper > .advertisement-content-img {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    padding: 0;
                    margin: 0 0 0 0;
                    box-sizing: border-box;
                }

                .advertisement-content-container > .advertisement-content-wrapper > .advertisement-content-img img {
                    width: 100%;
                    height: 100%;
                    -o-object-fit: cover;
                    object-fit: cover;
                    border-radius: 12px;
                }

                .advertisement-content-container > .advertisement-content-wrapper > .advertisement-content-text {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    padding: 0 0 0 0;
                    margin: 0 0 0 0;
                    box-sizing: border-box;
                }

                .advertisement-content-container > .advertisement-content-wrapper > .advertisement-content-text p {
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 30px;
                    letter-spacing: 0;
                    color: #000000;
                    margin-bottom: 15px;
                }

                @media (max-width: 767px) {
                    .advertisement-content-container > .advertisement-content-wrapper {
                        grid-template-columns: 1fr;
                        grid-gap: 0;
                        padding: 0;
                    }
                }

            `}</style>
            {(windowSize.width < 768) ? (
                <WaveLayout backgroundColor={'unset'} hamburgerMenuType={'black'} hamburgerMenu={false}
                            loginButtonMenu={true} registerButton={false} waveComponent={false} bgColor={true}
                            extraChildren={
                                <React.Fragment>
                                    <LandingColumnComp imgAlt={'İstanbul Evlilik'}/>
                                    <div className={'advertisement-content-container'}>
                                        <div className={'advertisement-content-wrapper'}>
                                            <div className={'advertisement-content-img'}>
                                                <Image src={reklammarried}
                                                     alt={'Pembe Panjur, Mutlu Hayatların Başlangıcı'}/>
                                            </div>
                                            <div className={'advertisement-content-text'}>
                                                <p>
                                                    Evlilik ya da ciddi ilişki için en önemli koşullardan biri tanışıp
                                                    yüz yüze görüşebilmektedir. Sitemiz bireylerin birbirlerine olan
                                                    mesafelerinin önemli olduğunun bilincindedir ve sistemi size bu
                                                    konuda yardımcı olmak üzere tasarlanmıştır. Üye olurken tanışmak
                                                    istediğiniz kişinin sizden en fazla ne kadar uzakta yaşamasını
                                                    tercih ettiğinizi belirtmeniz doğru olur. Bu sayede size en yakın
                                                    üyelerle tanışmayı gerçekleştirebilirsiniz. Pembe Panjur
                                                    gerektiğinde İstanbul Evlilik Sitesi gibi üyelerinin bulunduğu şehre
                                                    özel bir evlilik sitesi gibi hizmet vermektedir. Bu hizmet, üyelerin
                                                    aşkı uzaklarda arama sorununu tamamen ortadan kaldırır.
                                                </p>
                                                <p>
                                                    Sağlıklı ve mutlu bir ilişki kurabilmek için gereken tüm hizmetleri
                                                    sunan İstanbul Evlilik Sitesi hayatı paylaşmayı istediğiniz insanı
                                                    size daha da yakınlaştırma hedefiyle çalışmaktadır. İstanbul ve
                                                    yakınlarındaki tüm eş veya sevgili adaylarını tanımak için üye
                                                    olmanız yeterlidir.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            }
                >
                    <React.Fragment>
                        <KayitWrapper>
                            <MobileKayitForm/>
                        </KayitWrapper>
                        <LandingSubHeroArea frontMatter={data.LandingSubHeroAreaData}/>
                    </React.Fragment>
                </WaveLayout>
            ) : (
                <LandingLayout
                    bodyBackgroundColor={false}
                    heroArea={
                        <React.Fragment>
                            <DesktopHeroArea advertisement={''}/>
                        </React.Fragment>
                    }
                    heroAreaBackgroundImage={'/next/assets/images/mobile-landing-hero-background.jpg'}
                    heroAreaBackgroundImageDesktop={'/next/images/landing/landing-reklam-hero-area-min.webp'}
                    subHeroArea={
                        <React.Fragment>
                            <LandingSubHeroArea frontMatter={data.LandingSubHeroAreaData}/>
                        </React.Fragment>
                    }
                >

                    <React.Fragment>
                        <LandingColumnComp imgAlt={'İstanbul Evlilik'}/>
                        <div className={'advertisement-content-container'}>
                            <div className={'advertisement-content-wrapper'}>
                                <div className={'advertisement-content-img'}>
                                    <Image src={reklammarried}
                                         alt={'Pembe Panjur, Mutlu Hayatların Başlangıcı'}/>
                                </div>
                                <div className={'advertisement-content-text'}>
                                    <p>
                                        Evlilik ya da ciddi ilişki için en önemli koşullardan biri tanışıp
                                        yüz yüze görüşebilmektedir. Sitemiz bireylerin birbirlerine olan
                                        mesafelerinin önemli olduğunun bilincindedir ve sistemi size bu
                                        konuda yardımcı olmak üzere tasarlanmıştır. Üye olurken tanışmak
                                        istediğiniz kişinin sizden en fazla ne kadar uzakta yaşamasını
                                        tercih ettiğinizi belirtmeniz doğru olur. Bu sayede size en yakın
                                        üyelerle tanışmayı gerçekleştirebilirsiniz. Pembe Panjur
                                        gerektiğinde İstanbul Evlilik Sitesi gibi üyelerinin bulunduğu şehre
                                        özel bir evlilik sitesi gibi hizmet vermektedir. Bu hizmet, üyelerin
                                        aşkı uzaklarda arama sorununu tamamen ortadan kaldırır.
                                    </p>
                                    <p>
                                        Sağlıklı ve mutlu bir ilişki kurabilmek için gereken tüm hizmetleri
                                        sunan İstanbul Evlilik Sitesi hayatı paylaşmayı istediğiniz insanı
                                        size daha da yakınlaştırma hedefiyle çalışmaktadır. İstanbul ve
                                        yakınlarındaki tüm eş veya sevgili adaylarını tanımak için üye
                                        olmanız yeterlidir.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                </LandingLayout>
            )}


        </React.Fragment>
    )
}


const KayitWrapper = styled.div`
    position: relative;
    background: #0000000D;
    width: calc(100% + 70px);
    margin-left: -35px;

    @media ${deviceMax.tablet} {
        padding: 0 35px 20px;
        margin-bottom: 20px;
    }
`;


export default SiteTuru;
